<template>
	<div class="pages">
		<sub-ibox-title><p slot="title">自动回复管理</p></sub-ibox-title>
		<z-tab-bar :list-obj="tabBarParams.list" :active="tabBarParams.active" @handleClickTabBar = "handleClickTabBar"></z-tab-bar>
	  	<section class="content">
	  		<z-radio-material 
				:radio-bar-params ="radioBarParams" 
				:is-layer-material ="isLayerMaterial"
				@cancelMaterialLayer = "cancelMaterialLayer"
				@handleClickRadioBar ="handleClickRadioBar"
				@handleSetContent = "handleSetContent"
				>
			</z-radio-material>
			<div class="p-t-10 tips" v-show="tabBarParams.active =='autoreply'">
				<p>Tips：设置了自动回复,则自动应答机器人关闭,反之则开启。</p>
			</div>
	  		<div class="m-t-20">
	  			<a class="z-btn z-btn-primary b-r-3" @click="handleSubmit">保存</a>
	  		</div>
	  	</section>
	</div>
</template>
<script>
	import { mapActions, mapState, mapGetters } from 'vuex'
	export default {
		name: 'WxReply',
		components: {
		},
		data() {
			return {
				tabBarParams:{
					list:[{
						title:'关注后回复',
						type:'subscribe'
					},{
						title:'收到消息自动回复',
						type:'autoreply'
					}],
					active:'subscribe' //默认
				},
				radioBarParams: {
					list: [{
						title: '文字',
						type: 'text',
						content:''
					}, {
						title: '图文',
						type: 'news',
						content:''
					}, {
						title: '图片',
						type: 'image',
						content:''
					}, {
						title: '语音',
						type: 'voice',
						content:''
					}, {
						title: '视频',
						type: 'video',
						content:''
					}],
					active: 'text' //默认
				},
				isLayerMaterial :false,//是否显示素材弹出层
				replysContent:{},
				params:{
					id:null,
					type:'subscribe',//tabbar
					radioType:'text', //回复类型
					content:""
				},
			}
		},
		mounted() {
			this.handleGetReplys()
		},
		/*
		 * 属性计算
		 */
		computed: {
		},
		/*
		 * 事件处理
		 */
		methods: {
			cancelMaterialLayer(){//显示隐藏弹出层
				this.isLayerMaterial = this.isLayerMaterial ? false : true
			},
			handleClickTabBar(type){//切换tabbar
				this.tabBarParams.active = type
				this.radioBarParams.list.map((item,index)=>{
					item.content =''
				})
				this.handleGetReplys()
			},
			handleClickRadioBar(type){//切换radioBar
				this.radioBarParams.active = type
			},
			handleSetContent(content=null,type =null){//设置输入的内容
				let index = this.getKey()
				this.radioBarParams.list[index].content = content
			},
			getKey(){//获取index
				switch (this.radioBarParams.active){
					case 'text': return 0
					case 'news': return 1
					case 'image':return 2
					case 'voice':return 3
					case 'video':return 4
					default: return null
				}
			},
			setParamsContent(){//获取需要保存的内容
				let index = this.getKey()
				this.params.id = this.replysContent.id || null
				this.params.type = this.tabBarParams.active 
				this.params.radioType = this.radioBarParams.active 
				this.params.content = this.radioBarParams.list[index].content || null
				
			},
			async handleSubmit(){//保存回复内容
				this.setParamsContent()
//				if(!this.params.content) return this.$warning('请输发送内容唔/(ㄒoㄒ)/~~')
				try{
					await this.saveReplys(this.params)
					this.$success('保存成功')
					this.handleGetReplys()
					
				}catch(e){
					this.$errorMsg(e)
				}
			},
			async handleGetReplys(){//获取回复内容
				let replyType = this.tabBarParams.active
				try{
					const data = await this.getReplys()
					this.replysContent = data.filter(d=>d.type === replyType)[0] || {};
					this.radioBarParams.active = this.replysContent.reply_type || 'text'
					//设置单选组件内容
					let content = this.replysContent.content || {}
					this.handleSetContent(content)
				}catch(e){
					this.$error(e)
				}
			},
			...mapActions(['getReplys','saveReplys']),
		}
	}
</script>
<style scoped lang="scss">
@import "src/assets/css/common.scss";
.tips{
	color: $color-red;
}
@media only screen and (min-width:0px) and (max-width:640px) {
		.tab-bar,.content,.sub-ibox-title {
			min-width: px-em(800px);
		}	
	}
</style>


// WEBPACK FOOTER //
// WxReply.vue?d5b94c62